import React from "react";
import { Dropdown } from "react-materialize";
import { getDistance } from "../../../helpers/helper";

const SortOrderPickupsDropdown = ({ setOrder, organization, order }) => {
  return (
    <Dropdown
      trigger={
        <div
          style={{
            border: "2px solid #000",
            borderRadius: "5px",
            padding: "5px",
            cursor: "pointer",
          }}
          className="flex align-center gap-1"
        >
          <p className="">Arrange based on </p>
          <i className="material-symbols-outlined">keyboard_arrow_down</i>
        </div>
      }
    >
      <span >All parameters</span>
      <span disabled>Previous Delivery Quality</span>
      <span
        onClick={() => {
          order.pickups.sort((a, b) => a.price - b.price);
          setOrder({
            ...order,
            pickups: order.pickups,
          });
        }}
      >
        Best Price
      </span>
      <span
        onClick={() => {
          order.pickups.sort((a, b) => a.price - b.price);
          setOrder({
            ...order,
            pickups: order.pickups,
          });
        }}
        disabled
      >
        Best Price + Closest Location
      </span>
      <span
        onClick={() => {
          order.pickups.sort((a, b) => a.price - b.price);
          setOrder({
            ...order,
            pickups: order.pickups,
          });
        }}
       disabled 
      >
        Best Price + Delivery Quality
      </span>
      <span
        onClick={() => {
          order.pickups.sort(
            (a, b) =>
              getDistance(
                a.pickupLocation?.latitude,
                a.pickupLocation?.longitude,
                organization.locations[0]?.latitude,
                organization.locations[0]?.longitude
              ) -
              getDistance(
                b.pickupLocation?.latitude,
                b.pickupLocation?.longitude,
                organization.locations[0]?.latitude,
                organization.locations[0]?.longitude
              )
          );

          setOrder({
            ...order,
            pickups: order.pickups,
          });
        }}
      >
        Closest Location
      </span>
    </Dropdown>
  );
};

export default SortOrderPickupsDropdown;
